import React from "react";
import { useAppSelector } from "../../services/hooks";
import { creditsSelector } from "../../services/selectors/entitlements.selectors";
import { EntitlementsCreditsDto } from "../../services/types/users.types";
import { tWithKeyAttr as t } from "../../i18nHelper";
import { formatCredits } from "../../utils/featureCreditPackages";
import styles from "./AiTokenUsage.module.css";

const CompanyRow: React.FC<{ credits: EntitlementsCreditsDto }> = ({
  credits,
}) => {
  const { monthlyQuota, allowanceRemaining, purchasedCompanyBalance } = credits;
  return (
    <div className={styles.row}>
      <span className={styles.label}>{t("AI_TOKEN_COMPANY")}</span>
      <span className={styles.value}>
        {monthlyQuota === null || allowanceRemaining === null
          ? t("UNLIMITED")
          : t("AI_CREDIT_USED_OF", {
              used: formatCredits(monthlyQuota - allowanceRemaining),
              limit: formatCredits(monthlyQuota),
            })}
      </span>
      {purchasedCompanyBalance > 0 && (
        <span className={styles.purchased}>
          {t("AI_TOKEN_PURCHASED", {
            amount: formatCredits(purchasedCompanyBalance),
          })}
        </span>
      )}
    </div>
  );
};

// The backend sends the caller's seat only as a percentage, never as a credit figure.
const UserRow: React.FC<{ usedPercent: number | null }> = ({ usedPercent }) => (
  <div className={styles.row}>
    <span className={styles.label}>{t("AI_TOKEN_USER")}</span>
    <span className={styles.value}>
      {usedPercent === null
        ? t("UNLIMITED")
        : t("AI_CREDIT_USER_PERCENT_USED", {
            percent: Math.round(usedPercent),
          })}
    </span>
  </div>
);

const AiTokenUsage: React.FC = () => {
  const credits = useAppSelector(creditsSelector);

  if (!credits) return null;

  return (
    <div className={styles.wrapper}>
      <h4 className={styles.title}>{t("AI_CREDIT_USAGE_TITLE")}</h4>
      <CompanyRow credits={credits} />
      {credits.user && <UserRow usedPercent={credits.user.usedPercent} />}
    </div>
  );
};

export default AiTokenUsage;
